import _Vue from "vue";
import SpinnerToast from "@/components/SpinnerToast.vue";

export class SpinnerService {
  private spinnerComponent: SpinnerToast | null = null;

  /**
   * Spinner toast gösterir
   * @param message Gösterilecek mesaj
   * @param timeoutSeconds Kaç saniye sonra otomatik kapanacağı (varsayılan: 3)
   */
  message(message: string, timeoutSeconds: number = 3): void {
    if (!this.spinnerComponent) {
      // Component henüz mount edilmemişse, bir sonraki tick'te dene
      _Vue.nextTick(() => {
        if (this.spinnerComponent) {
          this.spinnerComponent.show(message, timeoutSeconds);
        }
      });
      return;
    }
    this.spinnerComponent.show(message, timeoutSeconds);
  }

  /**
   * Spinner toast'ı gizler
   */
  hide(): void {
    if (this.spinnerComponent) {
      this.spinnerComponent.hide();
    }
  }

  /**
   * Spinner component referansını set eder (App.vue tarafından çağrılır)
   */
  setComponent(component: SpinnerToast): void {
    this.spinnerComponent = component;
  }
}

export default function SpinnerPlugin(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$spinner = new SpinnerService();
}
